import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Button from 'components/common/Button'
import Text from 'components/common/Text'
import theme from 'theme'

function NoActiveAttacksContainer() {
  return (
    <div
      data-test-no-active-attacks
      css={{
        display: 'grid',
        gridTemplateRows: '1fr 1fr 1fr',
        gridTemplateColumns: '1fr',
        padding: theme.space[4],
        paddingTop: theme.space[3],
        textAlign: 'center',
        alignItems: 'center',
        minWidth: 280
      }}
    >
      <Text as="h4">No active attacks</Text>
      <Button
        as={Link}
        css={{
          justifyContent: 'center'
        }}
        to="/scenarios/new/hosts"
      >
        New Scenario
      </Button>
    </div>
  )
}

export function MenuItem({ headerName, children }) {
  return (
    <div
      css={{
        borderTop: `1px solid ${theme.colors.borderContrast[0]}`,
        '&:first-of-type': {
          borderTop: 'none'
        }
      }}
    >
      <div
        css={{
          padding: `${theme.space[3]}px ${theme.space[4]}px`,
          borderBottom: `1px solid ${theme.colors.borderContrast[0]}`
        }}
        data-active-attack-header-name={headerName}
      >
        <Text
          as="h4"
          css={{
            color: theme.colors.steel[2],
            fontWeight: theme.fontWeights[1]
          }}
        >
          {headerName}
        </Text>
      </div>
      <div
        css={{
          backgroundColor: theme.colors.white[0]
        }}
      >
        {children}
      </div>
    </div>
  )
}

MenuItem.propTypes = {
  headerName: PropTypes.node,
  children: PropTypes.node
}

export default function ListContainer({ isEmpty, children }) {
  if (isEmpty) {
    return <NoActiveAttacksContainer />
  }

  return (
    <div
      data-test-active-attacks-list-container
      css={{
        minWidth: 525,
        width: '100%',
        borderRadius: theme.borderRadius[0],
        backgroundColor: theme.colors.panel[0]
      }}
    >
      <div css={{ maxHeight: 300, overflow: 'scroll' }}>{children}</div>
    </div>
  )
}

ListContainer.propTypes = {
  children: PropTypes.node,
  isEmpty: PropTypes.bool
}
